module.exports = __webpack_public_path__ + "static/bianjing-8061bd92dbf96359c767dd1a918a3812.png";